import { Inbox, FileText, MessageSquare } from 'lucide-react';

const Stat = ({ icon: Icon, label, value, testId }) => (
  <div className="bg-white border border-gray-200 rounded-xl p-6 flex items-center gap-4" data-testid={testId}>
    <div className="w-11 h-11 rounded-lg bg-[#D94B5A]/10 flex items-center justify-center flex-shrink-0">
      <Icon className="h-5 w-5 text-[#D94B5A]" />
    </div>
    <div>
      <p className="text-2xl font-bold text-[#1F1F1F]">{value}</p>
      <p className="text-xs uppercase tracking-wide text-gray-500">{label}</p>
    </div>
  </div>
);

export const LeadStats = ({ total, quotes, contacts }) => (
  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
    <Stat icon={Inbox} label="Total leads" value={total} testId="stat-total" />
    <Stat icon={FileText} label="Quote requests" value={quotes} testId="stat-quotes" />
    <Stat icon={MessageSquare} label="Contact messages" value={contacts} testId="stat-contacts" />
  </div>
);
